import type { IncidentFamily } from "./incidentTypes";

export type IncidentWitnessIconSpec = {
  family: IncidentFamily;
  label: string;
  iconPath: string;
};

export const incidentIconOrder: IncidentFamily[] = [
  "tortureOrRape",
  "murdered",
  "missingOrAbducted",
  "massGrave",
];

export const incidentIconMap: Record<IncidentFamily, IncidentWitnessIconSpec> = {
  tortureOrRape: {
    family: "tortureOrRape",
    label: "Witnessed torture or rape",
    iconPath: "/torture-rape.png",
  },
  murdered: {
    family: "murdered",
    label: "Witnessed murdered persons",
    iconPath: "/murdered.png",
  },
  missingOrAbducted: {
    family: "missingOrAbducted",
    label: "Witnessed missing or abducted persons",
    iconPath: "/missing.png",
  },
  massGrave: {
    family: "massGrave",
    label: "Witnessed mass grave sites",
    iconPath: "/mass-grave.png",
  },
};
